import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { BadgeModule } from 'primeng/badge';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule ,ActivatedRoute } from '@angular/router';
import { Role } from '../role.model';
import { RolesService } from '../roles.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-list-roles',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    TableModule,
    BadgeModule,
    TagModule,
    ToastModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule
  ],
  templateUrl: './list-roles.component.html',
  styleUrl: './list-roles.component.css',
  providers: [ConfirmationService, MessageService]
})
export class ListRolesComponent implements OnInit {
  constructor(
    private rolesService: RolesService, 
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}
  
  roles: Role[] = [];
  isLoading: boolean = false;
  filterForm!: FormGroup;

  getStatusColor(status: string) {
    switch (status) {
      case 'inactive':
        return 'danger';
      case 'active':
        return 'info';
      default:
        return 'warning';
    }
  }

  ngOnInit() {
    this.buildFilterForm();
    this.getAllRoles();
  }

  buildFilterForm() {
    this.filterForm = this.fb.group({
      name: [''],
      description: ['']
    });
  }
 editRole(roleId: number): void {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['roles', 'edit', roleId] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }
  createRole(): void {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['roles', 'create'] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }
  

  getAllRoles() {
    this.isLoading = true;
    this.rolesService
      .getAllRoles({
        page: 0,
        size: 10,
      })
      .subscribe({
        next: (response) => {
          this.roles = response.content || [];
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error fetching roles:', error);
          this.isLoading = false;
        }
      });
  }
  deleteRole(Role: Role): void {

  this.confirmationService.confirm({
      message: 'Are you sure you want to delete this Role?',
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',

      acceptLabel: 'Yes, Delete',
      rejectLabel: 'Cancel',

      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-success',

      accept: () => {
        this.rolesService.deleteRole(Role.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: `Role Deleted successfully.`,
            });
            setTimeout(() => {
              this.getAllRoles();
            }, 500);
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Failed to Delete Role.`,
            });
            console.error(err);
          },
        });
      },
    });
  }
}